var root = 'fx_2d2fb1e5_sycfeq0';

export { root };
//# sourceMappingURL=textField.vanilla.mjs.map
